<template>
  <div  ref = 'canvasBox' id="canvasBox">
    <div class="signPicture" @click="addSign">
      <div class="signBox" v-if="!sign">
        <p class="iconfont icon-signature"></p>
        <p class="text">签名</p>
      </div>
      <div class="showSign" v-else>
        <img :src="sign" @click.stop="drowBoxShow=true">
      </div>
    </div>
    <!-- 签名 -->
    <van-popup v-model="drowBoxShow" position="bottom" get-container="#app"
               :style="{ height: '100%' }"
               :lazy-render="false">
      <div class="drowBox" :style='getHorizontalStyle'>
        <div class="doAction">
          <p>在方框中签名：</p>
        </div>
        <div class="doAction">
          <button type="button" class="close" @click="close">取消</button>
          <button type="button" class="clear" @click="clear">重新签名</button>
          <button type="button" class="rotate" @click="rotate">旋转画板</button>
          <button type="button" class="upload" @click="upload">上传签名</button>
        </div>
        <div class="canvasSection" :class="[degree===0?'vertical':'']" ref="canvasSection">
          <canvas ref="canvas" id="canvas"/>
        </div>
      </div>
      <!-- loading -->
      <van-overlay :show="showLoading"
                   :custom-style="{textAlign: 'center', backgroundColor: 'transparent'}">
        <van-loading color="#1989fa" :vertical="true" style="margin-top: 65%">
          上传中，请勿操作，耐心等待...
        </van-loading>
      </van-overlay>
    </van-popup>
  </div>
</template>

<script>
import Draw from '@/utils/draw';
import {getUploadToken} from '@/api/dictionary';
import {qiniuUrl} from '@/utils/baseUrl';

export default {
  props: {
    signature: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      draw: {},
      degree: 90,
      drowBoxShow: false,
      sign: '',
      token: '',
      upImgLink: '',
      showLoading: false,
    }
  },
  watch: {
    signature(newValue) {
      this.sign = newValue;
    }
  },
  created() {
    this.sign = this.signature || '';
    this.getQNToken();
  },
  mounted() {
    // this.canvasBox = document.getElementById('canvasBox');
     this.$nextTick(()=>{
       this.canvasBox = this.$refs.canvasBox
       this.initCanvas();
     })
  },
  computed: {
    getHorizontalStyle() {
      const d = document
      const w = window.innerWidth || d.documentElement.clientWidth || d.body.clientWidth
      const h = window.innerHeight || d.documentElement.clientHeight || d.body.clientHeight

      let width = this.degree === 90 ? parseInt(h - 20) : parseInt(w - 20);
      let height = this.degree === 90 ? parseInt(w - 112) : parseInt(w * 3 / 7 - 10);
      let length = (h - w) / 2

      // let width = h * 3 / 7 + 150
      // let height = h
      switch (this.degree) {
        case 90:
          width = h
          height = w
          break
        case -90:
          length = -length
          break
        default:
          length = 0
          width = w
          height = h
          break
      }

      if (this.canvasBox) {
        // 第二次
        let canvasDom = document.getElementById('canvas');
        this.$refs.canvasSection.removeChild(canvasDom);
        let node = document.createElement('canvas');
        node.setAttribute('id', 'canvas');
        node.setAttribute('ref', 'canvas');
        this.$refs.canvasSection.appendChild(node);
        this.initCanvas();
      }
      return {
        transform: `rotate(${this.degree}deg) translate(${length}px,${length}px)`,
        width: `${width}px`,
        height: `${height}px`,
        transformOrigin: 'center center',
      }

    }
  },
  methods: {
    getQNToken() {
      getUploadToken()
          .then(res => {
            if (res.state === 'Y') {
              this.token = res.data.token;
              this.upImgLink = res.data.url;
            } else {
              this.$toast(res.msg)
            }
          }).catch(err => {
        console.log(err);
        this.$toast(err);
      });
    },
    addSign() {
      this.drowBoxShow = true;
    },
    goBack() {
      this.clear()
      this.$parent.show = false;
    },
    initCanvas() {
      const canvas = document.getElementById('canvas');
      // let canvas = this.$refs.canvas
      this.draw = new Draw(canvas, -this.degree, {direction: this.degree === 0 ? 'vertical' : 'horizontal'});
    },
    clear() {
      this.draw.clear();
    },
    close() {
      this.drowBoxShow = false;
    },
    rotate() {
      this.draw = {};
      this.degree === 90 ? this.degree = 0 : this.degree = 90;

    },
    upload() {
      if (!this.token) {
        this.$toast('未获取到Token,请刷新页面后再试！')
      }
      const _this = this;
      const image = this.draw.getPNGImage();
      const blob = this.draw.dataURLtoBlob(image);
      const token = this.token;
      var key = new Date().getTime();
      var randomNum = parseInt(Math.random() * 10000);
      var formdata = new FormData();
      var formdataConfig = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      formdata.append('file', blob);
      formdata.append('key', key + '_' + randomNum + '.jpg');
      formdata.append('token', token);
      this.showLoading = true;
      this.$http.post(qiniuUrl, formdata, formdataConfig).then(res => {
        _this.showLoading = false;
        _this.drowBoxShow = false;
        if (res.data.key) {
          let imgUrl = _this.upImgLink + '/' + res.data.key;
          _this.sign = imgUrl;
          _this.$emit('setSignUrl', imgUrl);
        } else {
          _this.$toast('上传失败,请稍后再试！');
        }
      }).catch(err => {
        console.log(err)
        _this.showLoading = false;
        _this.drowBoxShow = false;
        _this.$toast(err);
      })
    }
  },
}

</script>

<style lang="stylus" scoped>

#canvasBox
  height 100%
  overflow hidden

  .signPicture
    width 100%
    position relative
    text-align center

    .signBox
      border 1px dashed #333
      border-radius 6px
      height 25vmin
      padding 4vmin 0
      line-height 8vmin

      .iconfont
        margin-top 3vw
        color #333
        font-size 5vmin
      .text
        font-size 5vw

    .showSign
      padding 1vmin 0
      border 1px dashed #333
      border-radius 6px
      width 100%
      position absolute
      top 0
      left 0
      background #fff
      font-size 0
      box-sizing border-box

      img
        height 27vmin
        vertical-align middle

.drowBox
  height 100%
  background-color #fff
  flex-direction column
  box-sizing border-box

  .doAction
    line-height 40px
    background-color #fff
    text-align right
    margin 0 0 10px 10px
    display flex

    p
      float right

    button
      padding 0 4vw
      background #ff0000
      color #fff
      border-radius 5px
      margin-right 10px
      height 40px
      line-height 40px
      box-sizing border-box
      outline none
      border 0

    button.close
      background-color #c5d6dd
      color #333

    button.upload
      background-color #2fbbdd

    button.rotate
      background-color #2AB774


  .canvasSection
    border 1px solid #999
    border-radius 10px
    cursor crosshair
    box-sizing border-box
    width auto
    height auto
    overflow hidden
    display inline-block
    margin-left 10px
    font-size 0
    &.vertical
      margin-top 50px
</style>
